<template>
  <div class="flex justify-center h-3 items-center w-full">
    <span class="w-1 h-1 mx-0.5 shrink-0 bg-outline rounded-md pulsating" />
    <span class="w-1 h-1 mx-0.5 shrink-0 bg-outline rounded-md pulsating" />
    <span class="w-1 h-1 mx-0.5 shrink-0 bg-outline rounded-md pulsating" />
  </div>
</template>
